import Handler from '@/core/domain/usecase/handler';

const fetchClientRepository = (axios) => async (pagination) => {
    try {
        const response = await axios.get('/client', {
            params: pagination
        })
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchClientRepository